<template>
  <v-app>
    <!-- <v-content style="background: url(../../public/background-image.jpg) top center / cover"> -->
        <v-content :style="{ background: 'url(' + image + ') top center / cover' }">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm4>
            <v-card class="elevation-12">
                 <v-card-media src="../../public/etracking-logo-long-large.gif" height="100px" contain ></v-card-media>    
                 <v-card-media v-if="additionalImage != ''" v-bind:src="'' + additionalImage" height="100px" contain ></v-card-media>    
                 <!-- <v-card-media src="../../public/additional-logo.jpg" height="100px" contain ></v-card-media>     -->
              <v-card-text style="text-align: center">
                <br>
                <div class="headline pb-3">{{ welcomeMessage }}</div>
                <div class="grey--text">Login below to access effort grades</div>
                <br>
                <v-alert :value="errorLogin" type="error" >{{ errorMessage }}</v-alert>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Email"   
                    required
                    v-on:keyup.13="hitEnter()" >
                  </v-text-field>
                  <v-text-field
                    v-model="password"
                    :rules="passwordRules"
                    :append-icon="e1 ? 'visibility' : 'visibility_off'"
                    :append-icon-cb="() => (e1 = !e1)"
                    :type="e1 ? 'password' : 'text'"
                    label="Password"
                    required
                    v-on:keyup.13="hitEnter()" >
                  </v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <div>
                  <v-layout row justify-center>
                    <v-btn color="primary" flat @click.stop="dlgResetPassword()">Forgot Password</v-btn>
                    <v-dialog v-model="dialog2" max-width="500px">
                      <v-card>
                        <v-card-title>
                          Forgot password
                        </v-card-title>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex xs12 class="my-3">
                              <v-flex xs12>
                                <v-text-field
                                  v-model="emailOnReset"
                                  label="Email"
                                  required
                                ></v-text-field>
                              </v-flex>
                              <v-alert :value="true" type="success" dismissible v-model="forgotPassSuccess">
                                  {{ forgotPassMessage }}
                              </v-alert>
                              <v-alert :value="true" type="error" dismissible v-model="forgotPassError">
                                  {{ forgotPassMessage }}
                              </v-alert>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn color="primary" flat @click.stop="dialog2=false">Close</v-btn>
                          <v-spacer></v-spacer>
                          <v-btn v-if="!forgotPassSuccess" color="primary"  @click.native="resetPassword()">Send reset instructions</v-btn>
                        </v-card-actions>
                      </v-card>
                      <v-alert :value="errorLogin" type="error" >{{ errorMessage }}</v-alert>
                    </v-dialog>
                  </v-layout>
                </div>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="login">LOGIN</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>    
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

  import { postUserLogin, getUserByIdentityId } from '../utils/effort-tracking-api'
  import { postForgotPassword, initialize, getActivePeriods, getActivePeriodsByUser, getVisiblePeriodsByUser } from '../utils/effort-tracking-api'
  import { getBackgroundImg, getImageBySettingsKey } from '../utils/effort-tracking-api'
  import { BASE_URL, getSettings, getPeriods, getStudentPeriodHasEfforts, getCompletedPeriods} from '../utils/effort-tracking-api'
  import { store } from '../store'
  
  export default {
    data: () => ({
        e1: true,
        valid: true,
        password: '',
        errorLogin: false,
        errorMessage: '',
        email: '',
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /^\w+([.-]?'?\w+)*@\w+([.-]\w+)+$/.test(v) || 'E-mail must be valid'
        ],
        passwordRules: [
            v => !!v || 'Password is required'
        ],
        dialog: false,
        dialog2: false,
        dialog3: false,
        notifications: false,
        sound: true,
        widgets: false,
        emailOnReset: '',
        resultMessage: '',
        errorMessage: '',
        error: false,
        success: false,
        forgotPassMessage: '',
        forgotPassSuccess: false,
        forgotPassError: false,
        welcomeMessage: '',
        image: '',
        additionalImage: ''
    }),

    methods: {
      login() {
        this.errorLogin = false;
        postUserLogin(this.email, this.password).then( result => { 
          if (result.status == 200) {
            var data = result.data;
            var usertype = data.userType
            var destination = '';
            var menuItems = [];
            var periodsWithEfforts = [];
            
            this.$store.commit('setUserData', data )
            
            getPeriods().then(periods => {
              if(usertype == 'admin')
              {
                if (periods.length > 0)
                {
                  localStorage.setItem('period-selected', '' + periods[0].value);
                }
                
                destination = `#/admin`;
                menuItems = ['Admin, Teachers, Students'];
                this.$store.state.isLoggedIn = true;
                window.location.href = destination;
              } else {
                getActivePeriodsByUser(this.$store.state.userdata.id, usertype).then(activePeriods => 
                {
                  if(activePeriods.length > 0) 
                  {
                    localStorage.setItem('period-selected', '' + activePeriods[0].rp.id);
                    switch (usertype)
                    {
                      case 'teacher':
                        destination = `#/teacher/` + data.id + '/teacher-efforts';
                        break;
                      case 'middlemanager':
                        destination = `#/teacher/` + data.id + '/teacher-efforts';
                        break;
                      case 'student':
                        destination = `#/student/` + data.id + '/student-efforts';
                        break;
                    }
                    
                    this.$store.state.isLoggedIn = true;
                    window.location.href = destination;

                  } else {
                    getVisiblePeriodsByUser(this.$store.state.userdata.id, usertype).then(visiblePeriods => {
                      if(visiblePeriods.length > 0)
                      {
                        localStorage.setItem('period-selected', '' + visiblePeriods[0].rp.id);
                        switch (usertype)
                        {
                          case 'teacher':
                            destination = `#/teacher/` + data.id + '/teacher-efforts';
                            break;
                          case 'middlemanager':
                            destination = `#/teacher/` + data.id + '/teacher-efforts';
                            break;
                          case 'student':
                            destination = `#/student/` + data.id + '/dashboard';
                            break;
                        }

                      } else {
                        destination = '#/';
                      }
                   
                      this.$store.state.isLoggedIn = true;
                      window.location.href = destination;

                    }); 
                  }            
                }).catch(ex => console.log(ex)); 
              }
            }).catch(ex => console.log(ex));
          } else {
            this.errorLogin = true;
            this.errorMessage = result.response.data.login_failure[0];
            this.password = ''
          }
        }).catch(ex => {
            this.errorLogin = true;
            this.errorMessage = "Unspecified error";
        });
      },

      usertype() {
        return this.user;
      },
      userdata() {
        return this.$store.state.userdata;
      },

      clear () {
        this.$refs.form.reset()
      },

      dlgResetPassword() {
        this.errorLogin = false;
        this.dialog2 = true;
      },
      resetPassword() {
        var jsEmail = {
          email : this.emailOnReset,
          host : window.location.protocol + "//" + window.location.hostname
        }
        this.forgotPassError = false;
        postForgotPassword(JSON.stringify(jsEmail))
        .then(result =>  { 
          if (result.status == 200) 
          {
              this.forgotPassSuccess = true;
              this.forgotPassMessage = "If your email is valid you will receive " +
              "a message with instructions to reset your password.";
          } else {
              this.forgotPassError = true;
              this.forgotPassMessage = 'Something went wrong, please try again.';    
          }})
        .catch( ex => console.log(ex));
      },

      hitEnter() {
        if (this.valid) 
          this.login()
      }
    },

    created() {
      localStorage.removeItem('period-selected');
        this.welcomeMessage = 'Welcome to EffortTracking';
        this.additionalImage = '';
        this.image = '';

        getBackgroundImg().then(result => {
                        this.image = (result.fileContents !== undefined ) ? 'data:' + result.contentType + ';base64,' + result.fileContents : '';
                    }).catch(ex => console.log(ex));
        
        getImageBySettingsKey('additional-logo').then(result => {
            this.additionalImage = (result.fileContents !== undefined ) ? 'data:' + result.contentType + ';base64,' + result.fileContents : '';
        }).catch(ex => console.log(ex));
        
        var welcomeText = localStorage.getItem('welcome-text');
        if(welcomeText != null && welcomeText.length > 0)
          this.welcomeMessage = welcomeText;

      initialize().then( x => {
        this.$store.state.classStudents = [];
        this.$store.state.isLoggedIn = false;
        this.$store.state.periods = [];
        this.$store.state.teacherClasses = [];
        this.$store.state.token = '';
        this.$store.state.userdata = null;
        this.$store.state.usertype = '';
        this.clear();
      });
     
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Users.vue